/**
 * 언어코드
 */
export enum USER_LANGUAGE {
  KR = 1, // 한국어. 실제로는 공식표기인 KO 로 활용 (ko.ts)
}
